import useBundleTranslation from 'i18n';
import { useAppBuilderContext } from 'app/app/editor/context';
import { Box, MenuItem } from '@mui/material';
import { IMenuItem } from 'app/app/editor/tabs/elements/layout/context-menu/index';
import styles from 'app/app/editor/tabs/elements/layout/context-menu/ContextMenu.styles';
import IconMi from 'components/common/icon/IconMi';
import insertNodeIntoPage from 'app/app/editor/page/insertNodeIntoPage';
import { processPageContainersUid } from 'app/app/editor/page';

export default function MenuAddMenuContainer({ openWithUid, handleClose }: IMenuItem) {
    const { t } = useBundleTranslation(['app/portal-page-builder']);
    const ctx = useAppBuilderContext();

    if (openWithUid != 'page') {
        return null;
    }

    const disabled = ctx.page.layout?.elements?.findIndex((node) => node.subtype == 'page_menu') != -1;

    return (
        <MenuItem
            disabled={disabled}
            onClick={() => {
                let parent = ctx.page.layout;

                // let newPage = insertNodeIntoPage(
                //     ctx.page,
                //     { type: 'container', params: { uid: '__mark' }, elements: structuredClone(parent.elements) },
                //     parent.params.uid,
                //     openWithUid,
                // );
                // processPageContainersUid(newPage.layout, 'container');
                //
                // newPage.layout.elements = newPage.layout.elements?.filter((node, index) => node.params.uid == '__mark');
                // const containerNode = getNodeByUid(newPage.layout, '__mark');
                // if (containerNode) {
                //     containerNode.params.uid = parent.params.uid + '-0__mark';
                // }
                // processPageContainersUid(newPage.layout, 'container');

                let newPage = insertNodeIntoPage(
                    ctx.page,
                    {
                        type: 'container',
                        subtype: 'page_menu',
                        params: {
                            uid: parent.params.uid + '-0__mark',
                            layout: {
                                width: '100px',
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 'auto',
                                bottom: 0,
                                resize: 'horizontal',
                                margin: '0',
                                'menu-collapse-type': 'x',
                            },
                        },
                    },
                    parent.params.uid,
                    openWithUid,
                );
                processPageContainersUid(newPage.layout, 'container');
                ctx.setPage(newPage, false);
                ctx.sendMessage({ name: 'reloadPage' });
                handleClose();
            }}
        >
            <Box sx={styles.iconHolder}>
                <IconMi icon={'sidebar-menu'} />
            </Box>
            <Box>{t('node_context_menu.add_menu_container')}</Box>
        </MenuItem>
    );
}
